import { Field, Input, InputGroup } from '@chakra-ui/react'
import { FormErrors } from 'commons/components/layout/FormErrors'
import { Label } from 'commons/components/layout/Label'
import { Section } from 'commons/components/layout/Section'
import { BgColors, TextColors } from 'commons/design-system/tokens'
import { FormStep } from 'commons/types/paymentTypes'
import type { ChangeEvent } from 'react'
import { useTranslation } from 'react-i18next'

type ZipCodeSectionProps = {
	errors: {
		zipcode?: string
	}
	isLoading: boolean
	step: FormStep
	isReadOnly: boolean
	zipcode: string
	onZipcodeChange?: (value: string) => void | undefined
	onClearError?: (field: 'zipcode') => void | undefined
}

export const ZipCodeSection = ({
	errors,
	isLoading,
	step,
	isReadOnly,
	zipcode,
	onZipcodeChange,
	onClearError
}: ZipCodeSectionProps) => {
	const { t } = useTranslation()
	const getBorder = (isError: boolean) =>
		isError ? `1px solid ${TextColors.STATUS_ERROR}` : `1px solid ${BgColors.Z3}`
	return (
		<Field.Root invalid={!!errors.zipcode}>
			<Section px={0} pt={2} pb={0}>
				<Label>{t('phone_form.verify_identity_manual_zipcode_label')}</Label>
				<InputGroup>
					<Input
						name='zipcode'
						autoComplete='postal-code'
						type='text'
						mt={2}
						fontFamily='Montserrat'
						fontWeight='500'
						border={getBorder(!!errors.zipcode)}
						borderRadius='6px'
						py={2}
						value={zipcode}
						onChange={(e: ChangeEvent<HTMLInputElement>) => {
							onZipcodeChange?.(e.target.value)
							if (errors.zipcode) {
								onClearError?.('zipcode')
							}
						}}
						_focus={{ outline: 'none', borderColor: 'blue.500', boxShadow: 'none' }}
						_focusVisible={{ outline: 'none', borderColor: 'blue.500', boxShadow: 'none' }}
						disabled={isLoading || step === FormStep.STEP_BIRTHDATE || isReadOnly}
						readOnly={isReadOnly}
						bg={isReadOnly ? BgColors.Z4 : BgColors.Z5}
					/>
				</InputGroup>
				{errors.zipcode && <FormErrors withoutBorder errors={[errors.zipcode]} />}
			</Section>
		</Field.Root>
	)
}
